import { PropertyDataV2 } from "commonModule/services/common";
import TWSkeleton from "components/utilities/TWSkeleton";
import { MAP_AREA } from "constant";
import useSearchListingPropertiesCount from "hooks/swr/useSearchListingPropertiesCount";
import { useAppSelector } from "stores/hooks";
import { selectIsBoundaryAutoRemoved } from "stores/search/searchSlice";
const PropertyLocationMessage = ({
  propertyData,
  locationName,
  isTheseNearByProperties,
  isPropertiesLoading
}: {
  propertyData?: PropertyDataV2[];
  locationName: string | undefined;
  isTheseNearByProperties: boolean;
  isPropertiesLoading: boolean;
}) => {
  const countApiResponse = useSearchListingPropertiesCount();
  const count = countApiResponse?.data?.originalCount || countApiResponse?.data?.count;
  const isBoundaryAutoRemoved = useAppSelector(selectIsBoundaryAutoRemoved);
  return <div className='flex flex-grow flex-wrap items-center justify-between gap-1' data-sentry-component="PropertyLocationMessage" data-sentry-source-file="PropertyLocationMessage.tsx">
      <div className='disable_click panel-2 m-0 ssm:min-w-[183px] min-[429px]:min-w-[211px] '>
        {/** When there is no properties in searched location and we remove the
         *   boundary automatically, we need to show a different message
         * indicating that the properties are of nearby locations.
         */}
        {isBoundaryAutoRemoved && !isPropertiesLoading && locationName !== MAP_AREA && <h1 className='pr-[5px] text-xs font-medium leading-normal text-textColor md:text-base'>
              {`We didn't find any stays in ${locationName}.`}{" "}
            </h1> || propertyData && propertyData.length > 0 && <h1 className={`pr-[5px] text-xs font-medium leading-normal text-textColor md:text-[13px]`}>
              {count !== null && count !== undefined && (count > 999 ? "Over" : "")}{" "}
              {count !== null && count !== undefined ? <span className='font-semibold '>
                  {Math.min(count, 1000)}
                  {count <= 999 && isTheseNearByProperties ? count !== propertyData.length : count !== countApiResponse?.data?.count ? "+" : ""}
                </span> : <TWSkeleton className='mr-2 inline-block h-3 w-10' />}{" "}
              {count && count > 1 ? "stays" : "stay"}{" "}
              {!isTheseNearByProperties ? locationName === MAP_AREA ? "within" : "in" : "near"}{" "}
              {locationName}
            </h1>}
      </div>
    </div>;
};
export default PropertyLocationMessage;